import React, {
  FC, useCallback, useEffect, useState,
} from 'react';
import { useTranslation } from 'react-i18next';

import { ComercialPdf } from '../comercialPdf';
import { SendComercialForm } from '../sendComercialForm';
import Button from 'components/base/Button';
import Modal from 'components/base/Modal';

import { useWindow } from 'hooks/useWindow';

import './index.scss';

type PrintComercialModalComponent = {
  show: boolean;
  onHide: () => void;
  erpId: number | undefined;
}

export const PrintComercialModal: FC<PrintComercialModalComponent> = ({
  show, onHide, erpId,
}) => {
  const { t } = useTranslation();
  const [url, setUrl] = useState<string>();
  const onLoadSuccess = ({ objectUrl }: { objectUrl: string }) => {
    setUrl(objectUrl);
  };
  const { openInNewTab } = useWindow();

  const openForPrint = useCallback(() => {
    if (url) {
      openInNewTab(url);
    }
  }, [url, openInNewTab]);

  useEffect(() => {
    if (!show) {
      setUrl(undefined);
    }
  }, [show]);

  return (
    <Modal
      className="f-print-comercial-modal"
      footerContent={(
        <React.Fragment>
          {erpId && (<SendComercialForm erpId={`${erpId}`} />)}
          <Button
            color="primary"
            text={t('common.print')}
            onClick={() => {
              openForPrint();
            }}
          />
        </React.Fragment>
)}
      show={show}
      title={t('article.flowers.printComercialTitle')}
      onHide={onHide}
    >
      <ComercialPdf erpId={erpId} onLoadSuccess={onLoadSuccess} />
    </Modal>
  );
};
